import styled from 'styled-components';

export const Wrapper = styled.div<{
  isDecimal?: boolean;
}>`
  border-radius: 8px;
  background-color: #ffffff;
  box-shadow: 0px 2px 8px -4px rgba(176, 192, 202, 0.2);
`;
